import UnsubscribeForm from './UnsubscribeForm';

export default UnsubscribeForm;
